module.exports = __webpack_public_path__ + "static/media/six_dot_icon.6975a421.svg";